import {
  CLEAN,
  INITIALIZE,
  SCHEDULES_RECEIVED,
  error,
  schedulesReceived,
  updateUpcomingShows,
} from '../store/modules/liveUpdatingShowList'
import {
  add,
  defaultTo,
  pipe,
  prop,
  reduce,
  filter as rfilter,
  map as rmap,
} from 'ramda'
import { combineEpics, ofType } from 'redux-observable'
import { formatSchedule, sortSchedulesByTime } from './schedules'
import {
  logObservableError,
  logObservableErrorAndTriggerAction,
} from '../utilities/logs'
import {
  map,
  mergeMap,
  switchMap,
  takeUntil,
  timer,
  withLatestFrom,
} from 'rxjs'

// fetchSchedulesEpic :: Epic :: Observable Action SCHEDULES_RECEIVED ERROR
export const fetchSchedulesEpic = (action$, state$, { logger, fetchApi, document }) =>
  action$.pipe(
    ofType(INITIALIZE),
    withLatestFrom(state$),
    mergeMap(([ _, state ]) => fetchApi(
      `/v2/${state.router.locale}/schedules?embed=show`,
    )),
    map(pipe(
      prop('body'),
      defaultTo([]),
      rmap(formatSchedule(document, new Date())),
      schedulesReceived,
    )),
    logObservableErrorAndTriggerAction(
      'liveRadio :: fetchSchedulesEpic',
      error,
      logger,
    ),
  )

// getDay :: Date -> Number
const getDay = date => (new Date(date)).getDay()

// elapsedSeconds :: Maybe String -> Number
const elapsedSeconds = pipe(
  moment => moment ? new Date(moment) : new Date(),
  date => [
    date.getHours() * 3600,
    date.getMinutes() * 60,
    date.getSeconds(),
  ],
  reduce(add, 0),
)

// isUpcoming :: Schedule -> Boolean
const isUpcoming = schedule =>
  // the schedule must begins the same day as the current day
  getDay(schedule.from) === getDay(new Date())
  && (
    // the schedule must ends after the current moment
    elapsedSeconds(schedule.to) > elapsedSeconds()
    // the above condition will not cover all cases
    // example : current time is monday(23:00)and schedule ends at sunday(01:00)
    // but in that case, the schedule start day will necessarily be different
    // than the schedule begin day
    || getDay(schedule.to) !== getDay(schedule.from)
  )

// refreshShowEpic :: Epic -> Observable Action UPDATE_CURRENT_SHOW
export const refreshShowEpic = (action$, state$, { logger }) =>
  action$.pipe(
    ofType(SCHEDULES_RECEIVED),
    switchMap(() => timer(0, 5000).pipe(
      takeUntil(action$.pipe(ofType(CLEAN))),
      withLatestFrom(state$),
      map(pipe(
        ([ _, state ]) => state.liveUpdatingShowList.schedules,
        rfilter(isUpcoming),
        sortSchedulesByTime,
        updateUpcomingShows,
      )),
    )),
    logObservableError('liveUpdatingShowList :: refreshShowEpic', logger),
  )

export default combineEpics(
  fetchSchedulesEpic,
  refreshShowEpic,
)
